import { Trans } from '@lingui/react/macro';

import { ColorBadge } from '@/components/typography';
import { COLOR_PINK_200, COLOR_TEAL_200, COLOR_VIOLET_200 } from '@/styles/palette';

type MatchType = 'Broad' | 'Phrase' | 'Exact';

type Props = {
  matchType: MatchType;
};

const KeywordMatchTypeTag = ({ matchType }: Props) => {
  if (matchType === 'Broad') {
    return (
      <ColorBadge color={COLOR_VIOLET_200} showTooltip={false}>
        <Trans>Broad</Trans>
      </ColorBadge>
    );
  }

  if (matchType === 'Phrase') {
    return (
      <ColorBadge color={COLOR_TEAL_200} showTooltip={false}>
        <Trans>Phrase</Trans>
      </ColorBadge>
    );
  }

  if (matchType === 'Exact') {
    return (
      <ColorBadge color={COLOR_PINK_200} showTooltip={false}>
        <Trans>Exact</Trans>
      </ColorBadge>
    );
  }

  return null;
};

export default KeywordMatchTypeTag;
